export const DataMutation_CreateCustomerAddress_QueryKey = {
  createCustomerAddress: (): string => {
    const queryKey = "data-mutation--create-customer-address";
    return queryKey;
  },
};
